/* eslint-disable import/no-unresolved */
import React from 'react';
import { Link } from 'gatsby';

import mobilevikingsSVG from 'assets/resources/pages/mobilevikings-logo.svg';

import { IoIosArrowRoundForward } from 'react-icons/io';
import OptimizedImage from '../../OptimizedImage';
import ImgHTML from '../../ImgHTML';
import useSitemap from '../../../graphql/staticQueries/useSitemap';

const Description = () => {
  const pages = useSitemap();
  const desiredPage = '/case-studies/mobile-vikings/';
  const altPage = '/case-studies/';
  const linkTo = pages.includes(desiredPage) ? desiredPage : altPage;
  return (
    <div className="main-beam">
      <div className="row">
        <div className="col-lg-5 col-mn-12">
          <div className="desc-section">
            <h2 className="subtitle bigger">
              We build software from scratch or
              <span style={{ display: 'inline' }}>
                support your development team
              </span>
            </h2>
            <div className="content text-format">
              <p>
                We partner with your company to develop software from scratch,
                but we can also support your development team by adding more
                power. Scale your team with one, two or more backend or frontend
                developers. We are more than happy to help you.
              </p>
              <p>
                We help teams that work with Scrum, value code quality, and have
                or are open to have deployed tools supporting work progress
                measuring and quality tracing.
              </p>
            </div>
            <Link to="/how-we-work/" className="btn btn-main narrow">
              Check how we work
            </Link>
          </div>
        </div>
        <div className="col-lg-7 col-md-12">
          <div className="image-section">
            <OptimizedImage
              src="pages/team-extension.png"
              className="img-fluid"
              alt="team extension image"
              title="team extension"
            />
            <Link to={linkTo} className="company-link">
              <div className="logo">
                <ImgHTML
                  src={mobilevikingsSVG}
                  alt="mobile vikings icon"
                  title="mobile vikings"
                />
              </div>
              <div className="link">
                <div className="read-more">
                  See related project <IoIosArrowRoundForward />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Description;
